import React from "react";

import { Box } from "@mui/material";
import type { CardConfig, PerformanceCardConfig } from "store/types";

import { RadioRow } from "./RadioRow";
import { SectionLabel } from "./SectionLabel";

interface Props {
  config: PerformanceCardConfig;
  onUpdateConfig: (c: CardConfig) => void;
}

export const PerformanceSettings: React.FC<Props> = ({ config, onUpdateConfig }) => {
  return (
    <>
      <Box>
        <SectionLabel>Sort By (Calculated Measure)</SectionLabel>
        <RadioRow
          label="IRR"
          selected={config.sortBy === "irr"}
          onChange={() => onUpdateConfig({ ...config, sortBy: "irr" })}
        />
        <RadioRow
          label="MOIC"
          selected={config.sortBy === "moic"}
          onChange={() => onUpdateConfig({ ...config, sortBy: "moic" })}
        />
        <RadioRow
          label="DPI"
          selected={config.sortBy === "dpi"}
          onChange={() => onUpdateConfig({ ...config, sortBy: "dpi" })}
        />
        <RadioRow
          label="RVPI"
          selected={config.sortBy === "rvpi"}
          onChange={() => onUpdateConfig({ ...config, sortBy: "rvpi" })}
        />
      </Box>
      <Box>
        <SectionLabel>Top N</SectionLabel>
        {[3, 5].map((n) => (
          <RadioRow
            key={n}
            label={`Top ${n}`}
            selected={config.topN === n}
            onChange={() => onUpdateConfig({ ...config, topN: n })}
          />
        ))}
      </Box>
    </>
  );
};
